import script from "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=script&setup=true&lang=js"

import "./SocioTherapyCoachingBillCorrectionForm.vue?vue&type=style&index=0&id=1abb09f4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1abb09f4"]])

export default __exports__